import { useMutation } from 'react-query';

import {
  CreateLandingPageLeadParams,
  CreateLandingPageLeadResponse,
  createLandingPageLead,
} from '@utils/backend-api/landingPage';

export default function useLandingPageLeadCreate() {
  const { mutate, mutateAsync, data, isLoading } = useMutation(
    (params: CreateLandingPageLeadParams) => createLandingPageLead(params),
    {
      onSuccess: (response: CreateLandingPageLeadResponse) => {
        if (response.redirectUrl) {
          window.location.href = response.redirectUrl;
        }
      },
    }
  );

  return { mutate, mutateAsync, data, isLoading };
}
